import { render, staticRenderFns } from "./SideImage.vue?vue&type=template&id=616c49ff&scoped=true&"
import script from "./SideImage.vue?vue&type=script&lang=js&"
export * from "./SideImage.vue?vue&type=script&lang=js&"
import style0 from "./SideImage.vue?vue&type=style&index=0&id=616c49ff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616c49ff",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VApp,VContainer,VMain})
